import { useEffect } from 'react';

import { useStores } from '../../../stores/useStores';

import { SofReactionDialog } from './SofReactionDialog';

export function useSofReactionDialog() {
  const { sofStore } = useStores();

  useEffect(() => {
    sofStore.SofReactionComponent = SofReactionDialog;
  }, [sofStore]);
}
